import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link } from 'react-router-dom';

var useStyles = makeStyles((theme) => ({
  root: {
    margin: '0',
    top: '0',
    left: '0',
    zIndex: '3000',
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: "center",
  }
}));

const CircularDeterminate = (props) => {
  var classes = useStyles();
  const [progress, setProgress] = React.useState(0);
  var close = false;
  React.useEffect(() => {
    function tick() {
      // reset when reaching 100%

      setProgress((oldProgress) => {
        if (!close){
          if(oldProgress > (props.max - 1) && props.compra){ 
            alert("Obrigado pela compra, acompanhe seu pedido na aba (MINHAS CARTELAS) ou continue comprando!");
            window.location.reload(false);
        }
            else if(oldProgress > (props.max - 1) && props.cambista){ 
              alert("Compra realizada com sucesso!");
              window.location.reload(false);
          }
          else if(oldProgress > (props.max - 1) && props.geraLote){ 
            alert("Lote gerado com sucesso!");
            window.location.reload(false);
        }
          return oldProgress <= (props.max - 1) ?  oldProgress + 1 : (close = true);
        }else {
          useStyles = makeStyles((theme) => ({
            root: {
              display: 'none',
          }}));
           // window.location.reload(false);
          return ""
        }
      });
    }

    const timer = setInterval(tick, 100);
    return () => {
     clearInterval(timer);
    };
  }, []);
  classes = useStyles()
  return (
    
    <div className={classes.root}>
      <h1 class="text-light">{progress}</h1>
      <CircularProgress
        variant="determinate"
        style={{
          position: "absolute",
          alignSelf: "center",
          width: "10em",
          height: "10em"
        }}
        value={progress}
        color="secondary"
      ></CircularProgress>
    </div>
  );
      
};

export default CircularDeterminate;
